// import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    marginBottom: theme.spacing(2.4),
    padding: theme.spacing(2.4),
    borderRadius: "12px",
    backgroundColor: theme.palette.common.white,
  },
  headerTitle: {
    fontWeight: "bold",
    color: theme.palette.common.normalTitle,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "19px",
    marginBottom: theme.spacing(2.4),
    [theme.breakpoints.up("sm")]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  headerTitleEmpty: {
    color: "grey",
    fontWeight: 500,
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
  },
  listContainerRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: theme.spacing(1.6),
  },
  itemText: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "21px",
  },
  greenText: {
    color: theme.palette.common.green,
  },
  itemPrice: {
    fontWeight: "bold",
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "21px",
  },
  total: {
    paddingTop: theme.spacing(1.9),
  },
  totalPrice: {
    fontSize: theme.typography.pxToRem(18),
  },
  grow: {
    flexGrow: 1,
  },
  btn: {
    // width: '100%',
    fontSize: theme.typography.pxToRem(16),
    border: "1px solid",
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
    textDecoration: " none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
    },
  },
  divider: {
    backgroundColor: theme.palette.common.grey,
  },
  mobileContainer: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      width: "100%",
    },
  },
  orderTypeModalContainer: {
    width: "450px",
    height: "auto",
  },
}));

export default useStyles;
